export default __webpack_public_path__ + "static/media/icon-hamburger.f512b225.svg";